<template>
  <div
    class="card-answer"
    :class="styleSelected()"
    @click="select()"
    >
    <div
      v-if="selected"
      class="answered"
      >
    </div>

    <div
      v-if="isMatch && !selected"
      class="check-text"
      >
      CHECK
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      required: true,
      type: Number
    }
  },

  computed: {
    selected: function () {
      return this.$store.state.answer.selected[this.index + 1]
    },

    isMatch: function () {
      return this.$store.getters['answer/isMatch'](this.index)
    }
  },

  methods: {
    styleSelected: function () {
      if (this.selected) {
        return { selected: true }
      }
      return {}
    },

    select: function () {
      this.$store.dispatch('answer/select', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_style.scss';
.card-answer {
  @include cell;
  border-right: 1px solid $wet-asphalt;

  &:hover {
    cursor: pointer;
  }
}

.answered {
  border-radius: 50%;
  border: 2px solid white;
  width: 60%;
  height: 60%;
}

.selected {
  background: $peter-liver;
}

.check-text {
  color: $peter-liver;
  font-size: 0.8em;
}
</style>
